import { useState } from "react";
import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FooterSettingsForm } from "@/components/admin/footer/FooterSettingsForm";
import { FooterLinksManager } from "@/components/admin/footer/FooterLinksManager";
import { useFooterSettings } from "@/hooks/useFooterSettings";
import { Skeleton } from "@/components/ui/skeleton";
import { FileText, Link2, Settings } from "lucide-react";
import { useNoIndex } from "@/hooks/useCanonicalTag";

export default function FooterSettings() {
  useNoIndex();
  const { isLoading } = useFooterSettings();

  if (isLoading) {
    return (
      <CandidateLayout>
        <div className="space-y-6">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-96 w-full" />
        </div>
      </CandidateLayout>
    );
  }

  return (
    <CandidateLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Configurações do Rodapé</h1>
          <p className="text-gray-600">Gerencie o conteúdo exibido no rodapé do site</p>
        </div>

        <Tabs defaultValue="general" className="w-full">
          <TabsList className="grid w-full grid-cols-3 max-w-md">
            <TabsTrigger value="general" className="flex items-center gap-2">
              <Settings className="h-4 w-4" />
              Geral
            </TabsTrigger>
            <TabsTrigger value="resources" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Recursos
            </TabsTrigger>
            <TabsTrigger value="useful" className="flex items-center gap-2">
              <Link2 className="h-4 w-4" />
              Links Úteis
            </TabsTrigger>
          </TabsList>

          <TabsContent value="general" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Configurações Gerais</CardTitle>
                <CardDescription>
                  Edite a descrição da empresa e informações de copyright
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FooterSettingsForm />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="resources" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Links de Recursos</CardTitle>
                <CardDescription>
                  Gerencie os links da seção "Recursos" no rodapé
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FooterLinksManager section="resources" />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="useful" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Links Úteis</CardTitle>
                <CardDescription>
                  Gerencie os links da seção "Links Úteis" no rodapé
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FooterLinksManager section="useful_links" />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </CandidateLayout>
  );
}
